import { CSSProperties } from "react";
import { StylesConfig } from "react-select";
import {
  CashierWelcome,
  IAccountForm,
  IUserFields,
  MyOptionType,
  Proccesor,
} from "src/types";
import ImgCoin from "src/assets/images/cashier/guarantecoin.png";
import ImgFrozen from "src/assets/images/frozen.png";
import DolarOneImage from "./../assets/images/header/b07.png";
import ProfileDefaultImage from "./../assets/images/profiledefault.png";
import ProfileDefaultImage2 from "./../assets/images/cashier/user-default.png";
import Compressor from "compressorjs";
//import ImgEmpty from "src/assets/images/cashier/empty-range.png";
import ImgEmpty from "src/assets/images/empty-folder.png";
import LogoComment from "src/assets/images/logo/logoblack.png";
//import moment from "moment";
import moment from "moment-timezone";
type permissionsRole = {
  type: string;
  enableRoutes: string[];
};


export const inputUsdWithNegative = (value: string) => {
  // Permite números, punto decimal y signo negativo al inicio
  value = value.replace(/[^\d.-]/g, "");
  
  // Asegura que el signo negativo solo esté al inicio
  const hasNegativeAtStart = value.startsWith("-");
  value = value.replace(/-/g, ""); // Remueve todos los signos negativos
  if (hasNegativeAtStart) {
    value = "-" + value;
  }
  
  const parts = value.split(".");
  if (parts.length > 1) {
    parts[1] = parts[1].slice(0, 2); // Limita a 2 decimales
    value = parts.join(".");
  }

  // Asegura que solo haya un punto decimal
  const points = value.split(".").length - 1;
  if (points > 1) {
    // Elimina el punto adicional
    value = value.substring(0, value.lastIndexOf("."));
  }
  return value;
};

export const inputUsd = (value: string) => {
  value = value.replace(/[^\d.]/g, "");
  const parts = value.split(".");
  if (parts.length > 1) {
    parts[1] = parts[1].slice(0, 2); // Limita a 2 decimales
    value = parts.join(".");
  }

  // Asegura que solo haya un punto decimal
  const points = value.split(".").length - 1;
  if (points > 1) {
    // Elimina el punto adicional
    value = value.substring(0, value.lastIndexOf("."));
  }
  return value;
};

export const dateToLocal = (fecha:any):string => {
  return  moment.utc(fecha).local().format('YYYY/MM/DD');
}
export const dateToLocalHour = (fecha:any):string => {
  return  moment.utc(fecha).local().format('HH:mm');
}
export const dateToLocalComplete = (fecha:any):string => {
  return  moment.utc(fecha).local().format('YYYY/MM/DD HH:mm');
}


export const getHourDateExpirate = (fechaString:string, minutosASumar:any) => {
 /*  // 1. Crear un objeto Date a partir de la cadena de fecha
  const fecha = new Date(fechaString);

  // 2. Sumar los minutos
  fecha.setMinutes(fecha.getMinutes() + minutosASumar);

  // 3. Formatear la fecha resultante (opcional)
  const año = fecha.getFullYear();
  const mes = String(fecha.getMonth() + 1).padStart(2, '0');
  const dia = String(fecha.getDate()).padStart(2, '0');
  const horas = String(fecha.getHours()).padStart(2, '0');
  const minutos = String(fecha.getMinutes()).padStart(2, '0');
  //const segundos = String(fecha.getSeconds()).padStart(2, '0');

  const fechaFormateada = `${año}/${mes}/${dia} ${horas}:${minutos}`;

  // 4. Devolver la fecha formateada */
  const fechaFormateada = moment(fechaString).add(parseInt(minutosASumar),'minutes').format('YYYY/MM/DD HH:mm')
  return fechaFormateada;
}


/* export const getHourDateExpirate = (fecha:string, minutosASumar:any) => {
  let mins = minutosASumar.toString()
  let date = moment.utc(fecha).local()
  date = date.add(15,'minutes')
  return  date.format('YYYY/MM/DD HH:MM');
} */
/* export const getHourDateExpirate = (
  fecha: string,
  minutosASumar: any
): string => {
  let mins = parseInt(minutosASumar);
  let fechaMoment = moment.parseZone(fecha);
  fechaMoment.add(mins, "minutes");
  // Crea una copia del objeto moment.js antes de formatearlo
  let fechaMomentCopy = fechaMoment.clone();
  let fechaResultante = fechaMomentCopy.format("YYYY/MM/DD HH:MM:ss");
  return fechaResultante;
};
 */
export const getRoleName = (rol?: string) => {
  switch (rol) {
    case "cashier":
      return "CAJERO";
    case "user":
      return "USUARIO";
    default:
      return rol || "desconocido";
  }
};
export const getTransferLink = (role: string, id: string) => {
  switch (role) {
    case "cashier":
      return `/cashier/transferencia/${id}`;
    case "user":
      return `/transferencia/${id}`;
      case "admin":
        return `/admin/transferencia/${id}`;
    case "weltrade-moderator":
          return `/admin/transferencia/${id}`;        
    default:
      return `/cashier/transferencia/${id}`;
  }
};

export const getNameStatus = (status: string) => {
  switch (status.toLowerCase()) {
    case "active":
      return "Activo";
    case "inactive":
      return "Inactivo";
    default:
      return "Desconocido";
  }
};

export const getSubString = (s: string) => {
  const r = Math.floor(Math.random() * 3) + 1;
  
    return s.substring(0, 500) + "..";
};

export const getNameStatusTransfer = (status: string) => {
  switch (status.toLowerCase()) {
    case "completed":
      return "completado";
    case "rejected":
      return "Rechazada";
    case "refused":
      return "Rechazada";
    default:
      return "Desconocido";
  }
};

/* export const money = (x: any) => {
  if (!x) x = "";
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}; */

const currencyToLocale = {
  ARS: "es-AR", // Peso argentino
  BOB: "es-BO", // Boliviano boliviano
  BRL: "pt-BR", // Real brasileño
  CLP: "es-CL", // Peso chileno
  COP: "es-CO", // Peso colombiano
  CRC: "es-CR", // Colón costarricense
  CUP: "es-CU", // Peso cubano
  DOP: "es-DO", // Peso dominicano
  GTQ: "es-GT", // Quetzal guatemalteco
  HNL: "es-HN", // Lempira hondureño
  MXN: "es-MX", // Peso mexicano
  NIO: "es-NI", // Córdoba nicaragüense
  PAB: "es-PA", // Balboa panameño
  PEN: "es-PE", // Sol peruano
  PYG: "es-PY", // Guaraní paraguayo
  UYU: "es-UY", // Peso uruguayo
  VES: "es-VE", // Bolívar venezolano
  USD: "en-US", // Dólar estadounidense (usado en algunos países)
  EUR: "de-DE", // Euro
};

export const formatCurrency = (amount: any, currencyCode: string) => {
  //@ts-ignore
  const locale = currencyToLocale[currencyCode.toUpperCase().trim()];
  if (!locale) {
    throw new Error(
      `Configuración regional no encontrada para la moneda ${currencyCode.toUpperCase()}`
    );
  }

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode.toUpperCase(),
  }).format(amount);
};

export const formatCurrencyWithoutSymbol = (
  amount: any,
  currencyCode: string
) => {
  //@ts-ignore
  const locale = currencyToLocale[currencyCode.toUpperCase()];
  if (!locale) {
    throw new Error(
      `Configuración regional no encontrada para la moneda ${currencyCode.toUpperCase()}`
    );
  }

  return new Intl.NumberFormat(locale, {
    style: "decimal", // Usamos 'decimal' en lugar de 'currency'
    minimumFractionDigits: 2, // Aseguramos que se muestren dos decimales
    maximumFractionDigits: 2, // Aseguramos que se muestren dos decimales
  }).format(amount);
};

export const validateInputUsd = (value: string) => {
  value = value.replace(/[^\d.]/g, "");
  const parts = value.split(".");
  if (parts.length > 1) {
    parts[1] = parts[1].slice(0, 2); // Limita a 2 decimales
    value = parts.join(".");
  }

  // Asegura que solo haya un punto decimal
  const points = value.split(".").length - 1;
  if (points > 1) {
    // Elimina el punto adicional
    value = value.substring(0, value.lastIndexOf("."));
  }
  return value;
};

export const moneyInput = (x: number | string) => {
  if (!x) x = "";
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

/* export const moneyInput = (x: any) => {
  if (!x) return "";

  const str = x.toString().replace(/\D/g, ""); // Eliminar caracteres no numéricos
  if (!str) return "";

  let result = "";
  let count = 0;

  for (let i = str.length - 1; i >= 0; i--) {
    result = str[i] + result;
    count++;

    if (count % 3 === 0 && i !== 0) {
      result = "." + result;
    }
  }

  return result;
}; */
export const money = (
  x: any,
  locale: string = "es-ES",
  currency: string = "USD"
) => {
  if (x === null || x === undefined || x === "") return ""; // Manejo de valores nulos o vacíos

  const number = typeof x === "number" ? x : parseFloat(x); // Convertir a número si es necesario

  return number.toLocaleString(locale, {
    currency: currency,
  });
};

export const SelectWithdrawOptions = (option: any) => {
  const { innerProps, innerRef } = option;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="flex items-center flex-wrap justify-between p-2 hover:bg-gray-200  cursor-pointer"
    >
      <div className="font-medium flex items-center gap-x-2 text-sm">
        {(option?.data.image?.length || 0) > 0 ? (
          <img src={option.data.image} alt="processor" className="w-36" />
        ) : (
          option.data.label
        )}
      </div>
    </div>
  );
};

export const SelectSimpleOption = (option: any) => {
  const { innerProps, innerRef } = option;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="flex items-center flex-wrap justify-between p-2 hover:bg-gray-200  cursor-pointer"
    >
      <div className="font-medium flex items-center gap-x-2 text-sm">
        {option.data.label}
      </div>
    </div>
  );
};

export const getCoinImage = () => {
  return ImgCoin;
};
export const getFrozenImage = () => {
  return ImgFrozen;
};
export const getLogoComment = () => {
  return LogoComment;
};
export const getEmptyImg = () => {
  return ImgEmpty;
};
const addHours = (date: any, hours: any) => {
  date.setTime(date.getTime() + hours * 60 * 60 * 1000);

  return date;
};

export const getOptionsProcessors = (processors: Proccesor[]) => {
  return processors
    ?.filter((p) => p.status === "active")
    ?.map((p) => ({
      value: p.id,
      label: p.name,
      image: `${process.env.REACT_APP_PROCESSOR_IMAGE}${p.photoUrl}`,
    }));
};

export const getProfileDefaultImage = () => {
  return ProfileDefaultImage;
};
export const getProfileDefaultImage2 = () => {
  return ProfileDefaultImage2;
};

export const getHourDate = (x: any) => {
  const date = new Date(parseInt(x));
  let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  let mins =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  return `${hours}:${mins}`;
};
export const getHourDateString = (x: any) => {
  const date = new Date(x);
  let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  let mins =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  return `${hours}:${mins}`;
};

export const getLocalDay = (diaEnIngles: string) => {
  const diasEnIngles = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];
  const index = diasEnIngles.indexOf(diaEnIngles.toLowerCase());
  if (index === -1) {
    return "Día inválido";
  } /* Crear una fecha cualquiera que coincida con el día de la semana */

  const fecha = new Date();
  const diaActual = fecha.getDay(); // Obtener el día actual (0-6, donde 0 es domingo)
  // Ajustar la fecha al día de la semana correcto
  const diasAjuste = (index - diaActual + 7) % 7;
  fecha.setDate(fecha.getDate() + diasAjuste);

  return fecha.toLocaleDateString(undefined, { weekday: "long" });
};

export const getDollarOneImg = () => {
  return DolarOneImage;
};
export const isMobileDevice = function () {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor);
  return check;
};

export const mobileCheck = function () {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor);
  return check;
};

export const openWhatsapp = (phone?: string) => {
  //const isMobile = navigator?.userAgentData?.mobile
  let route = `https://web.whatsapp.com/send?phone=${phone}`;

  if (mobileCheck()) {
    route = `https://wa.me/${phone}`;
  }
  // @ts-ignore
  window?.open(route, "_blank").focus();
};

export const getSlug = (str: string) => {
  return String(str)
    .normalize("NFKD") // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, "") // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, "") // remove non-alphanumeric characters
    .replace(/\s+/g, "-") // replace spaces with hyphens
    .replace(/-+/g, "-"); // remove consecutive hyphens
  //return name.trim().replaceAll(' ','-').replaceAll('.','').toLowerCase().replaceAll('á','a').replaceAll('é','e').replaceAll('í','i').replaceAll('ó','o').replaceAll('ú','u').replaceAll('ñ','n')
};

export const classNames = (...classes: any[]) => {
  return classes.filter(Boolean).join(" ");
};

export const getMonthName = (month: any) => {
  const m = month.toString();
  switch (m) {
    case "1":
      return "Enero";
    case "2":
      return "Febrero";
    case "3":
      return "Marzo";
    case "4":
      return "Abril";
    case "5":
      return "Mayo";
    case "6":
      return "Junio";
    case "7":
      return "Julio";
    case "8":
      return "Agosto";
    case "9":
      return "Septiembre";
    case "10":
      return "Octubre";
    case "11":
      return "Noviembre";
    case "12":
      return "Diciembre";
  }
};
export const compressFile = (file: File) => {
  new Compressor(file, {
    quality: 0.2,
    success: (compressedResult) => {
      return compressedResult;
    },
  });
  return undefined;
};

export const getProfilePicture = (photoUrl: string) => {
  let photo =
    photoUrl?.length || 0 === 0
      ? getProfileDefaultImage()
      : process.env.REACT_APP_PROFILEPICTURE + photoUrl;
  return photo;
};

export const validateDolar = (valor: string) => {
  // Eliminar espacios en blanco al principio y al final
  valor = valor.trim();

  // Expresión regular para validar el formato del dólar
  const regex = /^\$?\d+(\.\d{1,2})?\s?USD?$/i;

  // Verificar si el valor coincide con la expresión regular
  if (regex.test(valor)) {
    return true; // Valor válido
  } else {
    return false; // Valor inválido
  }
};

export const getLogout = () => {
  if (!window.location.pathname.includes("/logout-secure")) {
    window.location.href = "/logout-secure";
  }
};
export const generateCode = () => {
  const char = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "J",
    "K",
    "L",
    "M",
    "N",
    "P",
    "R",
    "W",
    "X",
    "Y",
  ];

  const code =
    char[Math.floor(Math.random() * char.length + 0)] +
    "-" +
    Math.floor(Math.random() * 999999 + 100000);
  return code;
};

export const AMPM = (time: any) => {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
};

export const redirectWelcomeCashier = (
  cashierWelcome: CashierWelcome,
  user: IUserFields
) => {
  if (!user?.nickname?.length && user.role === "cashier") {
    return `/usuario/${user?.id}/apodo`;
  } else if (!cashierWelcome.processors) {
    return "/cashier/procesadores";
  } else if (!cashierWelcome.ranges) {
    return "/cashier/rangos";
  } else if (!cashierWelcome.accounts) {
    return "/cashier/recibir-dinero";
  } else if (!cashierWelcome.schedule) {
    return "/cashier/horario";
  } else {
    return "";
  }
};
export const onlyTextString = (string: string) => {
  const regex = /[^A-Za-z\s]/g;
  return string.replace(regex, "");
};
export const getFiatName = (id: any, processors: Proccesor[]) => {
  return processors?.find((p) => p?.id === id)?.systemFiat?.name || "-";
};

export const getAccountToPayClient = (methodPayment: IAccountForm, t: any) => {
  return (
    <>
      <div className="flex justify-center w-full gap-1 font-semibold">
        <div className="flex gap-2">
          <img
            alt={methodPayment?.systemProcessor?.name}
            className="w-auto h-14"
            src={`${process.env.REACT_APP_PROCESSOR_IMAGE}${methodPayment?.systemProcessor?.photoUrl}`}
          />
        </div>
      </div>

      <div className="flex flex-col  gap-1">
        <div className="border-stone-400 pb-1 border-b border-dashed">
          {methodPayment?.systemProcessor?.type === "wallet" && (
            <>
              <div>
                {methodPayment?.systemProcessor?.name &&
                methodPayment?.systemProcessor?.name?.toLocaleLowerCase() ===
                  "deriv" ? (
                  <label className="font-semibold">{t("accounts.derivcr")}</label>
                ) : (
                  <label className="font-semibold">
                    {t("accounts.emailwallet")}
                  </label>
                )}
              </div>
            </>
          )}

          {methodPayment?.systemProcessor?.type === "bank" && (
            <label className="font-semibold">
              {t("accounts.numbercomplete")}
            </label>
          )}
          {methodPayment?.systemProcessor?.type === "crypto" && (
            <label className="font-semibold">{t("accounts.publickey")}</label>
          )}
          <div className="font-medium rounded-sm"> {methodPayment?.number}</div>

        </div>

        {methodPayment?.systemProcessor?.type === "crypto" && (
          <div>
            Tipo de Red: {methodPayment?.typered}
          </div>
        )}
 
        {methodPayment?.accounttype &&
          (methodPayment?.accounttype?.length || 0) > 0 && (
            <div>
              {t("accounts.typeaccount")}:{" "}
              {t(`bankaccounttype.${methodPayment.accounttype}`)}
            </div>
          )}
        <div className="font-normal">
          {(methodPayment?.nametitular?.length || 0) > 0 && `Titular:`}{" "}
          {methodPayment?.nametitular}{" "}

          <div>
            {(methodPayment?.identificationtype?.length || 0) > 0 && (
              <div>
                {t(`identification.${methodPayment?.identificationtype}`)}
              </div>
            )}
            <div>
            {(methodPayment?.identification?.length || 0) > 0 &&
            <div>
              {methodPayment?.identification}
            </div>
            }
            </div>
            {(methodPayment?.codeQR?.length || 0 ) > 0 && 
            <div className="flex justify-center">
              <img 
              src={`${process.env.REACT_APP_QR_IMAGE}${methodPayment?.codeQR}`}
              className="w-36"
              alt="QR"
              />
            </div>
            }
          </div>
        </div>
      </div>
    </>
  );
};

export const validateRouteRole = (role: string) => {
  const permissions: permissionsRole[] = [
    {
      type: "moderator",
      enableRoutes: ["/admin", "/admin/blog", "/admin/blog/guardar"],
    },
    {
      type: "admin",
      enableRoutes: ["*"],
    },
    {
      type: "cashier",
      enableRoutes: ["/cashier", "/cashier/depositos", "/cashier/depositos/"],
    },
    {
      type: "cajerobolivares",
      enableRoutes: [
        "/admin",
        "/admin/depositos-bolivares",
        "/admin/transferencia/detalle",
      ],
    },
    {
      type: "weltrade-moderator",
      enableRoutes: [
        "/admin",
        "/admin/weltrade",
        "/admin/usuario/",
        "/admin/transferencia/detalle",
      ],
    },
    {
      type: "provider",
      enableRoutes: [
        "/admin/app/provider",
      ],
    },    
    {
      type: "contador",
      enableRoutes: [
        "/admin",
        "/admin/depositos",
        "/admin/transferencia",
        "/admin/transferencia/detalle",
      ],
    },    
    {
      type: "user",
      enableRoutes: ["/usuario/"],
    },
  ];
  return permissions.find((p) => p.type === role)?.enableRoutes || [];
};

export const customControlStyles: CSSProperties = {
  boxShadow: "none",
  color: "#113843",
  height: "50px",
  width: "100%",
};
type IsMulti = false;
export const selectStyle: StylesConfig<MyOptionType, IsMulti> = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: "#FFF",
    color: state.isSelected ? "#D1D5DB" : "#113843",
    height: "auto",
    "&:hover": {
      backgroundColor: "#FDEADD",
    },
  }),
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#FFF",
    borderColor: state.isFocused ? "#D1D5DB" : "#D1D5DB",
    borderRadius: "5px",
    fontWeight: "600",
    boxShadow: state.isFocused ? "#D1D5DB" : "#D1D5DB",
    "&:hover": {
      borderColor: state.isFocused ? "#D1D5DB" : "#D1D5DB",
      boxShadow: "none",
    },
    height: "50px",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#113843",
  }),
  menu: (provided, state) => ({
    ...provided,
    margin: 0,
  }),
  container: (provided, state) => {
    return {
      ...provided,
      ...customControlStyles,
    };
  },
};

export const selectStyleTransfer: StylesConfig<MyOptionType, IsMulti> = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor: "#FFF",
    color: state.isSelected ? "#D1D5DB" : "#113843",
    height: "auto",
    "&:hover": {
      backgroundColor: "#FDEADD",
    },
  }),
  control: (provided, state) => ({
    ...provided,
    backgroundColor: "#FFF",
    borderColor: state.isFocused ? "#D1D5DB" : "#D1D5DB",
    borderRadius: "5px",
    textTransform: "uppercase",
    fontSize: "16px",
    fontWeight: "600",
    boxShadow: state.isFocused ? "#D1D5DB" : "#D1D5DB",
    "&:hover": {
      borderColor: state.isFocused ? "#D1D5DB" : "#D1D5DB",
      boxShadow: "none",
    },
    height: "50px",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: "#113843",
  }),
  menu: (provided, state) => ({
    ...provided,
    margin: 0,
  }),
  container: (provided, state) => {
    return {
      ...provided,
      ...customControlStyles,
    };
  },
};

export const getDeviceName = () => {
  var deviceName = "";

  var isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    Datalogic: function () {
      return navigator.userAgent.match(/DL-AXIS/i);
    },
    Bluebird: function () {
      return navigator.userAgent.match(/EF500/i);
    },
    Honeywell: function () {
      return navigator.userAgent.match(/CT50/i);
    },
    Zebra: function () {
      return navigator.userAgent.match(/TC70|TC55/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return (
        isMobile.Datalogic() ||
        isMobile.Bluebird() ||
        isMobile.Honeywell() ||
        isMobile.Zebra() ||
        isMobile.BlackBerry() ||
        isMobile.Android() ||
        isMobile.iOS() ||
        isMobile.Windows()
      );
    },
  };

  if (isMobile.Datalogic()) deviceName = "Datalogic";
  else if (isMobile.Bluebird()) deviceName = "Bluebird";
  else if (isMobile.Honeywell()) deviceName = "Honeywell";
  else if (isMobile.Zebra()) deviceName = "Zebra";
  else if (isMobile.BlackBerry()) deviceName = "BlackBerry";
  else if (isMobile.iOS()) deviceName = "iOS";
  else if (deviceName == "" && isMobile.Android()) deviceName = "Android";
  else if (deviceName == "" && isMobile.Windows()) deviceName = "Windows";

  if (deviceName != "") {
  }

  return deviceName;
};

export const encrypt = () => {};

export const encriptarString = (str: string, clave = "54w3r010g05") => {
  let strEncriptado = "";
  for (let i = 0; i < str.length; i++) {
    let charCode = str.charCodeAt(i);
    let claveCharCode = clave.charCodeAt(i % clave.length); // La clave se repite si es más corta
    let charEncriptado = String.fromCharCode(charCode ^ claveCharCode); // XOR
    strEncriptado += charEncriptado;
  }
  return strEncriptado;
};

export const desencriptarString = (
  strEncriptado: string,
  clave = "54w3r010g05"
) => {
  return encriptarString(strEncriptado, clave); // Se usa la misma función para desencriptar con XOR
};

export const convertirFechaAUsuario = (fecha:any) => {
  const anio = fecha.getUTCFullYear();
  const mes = String(fecha.getUTCMonth() + 1).padStart(2, '0');
  const dia = String(fecha.getUTCDate()).padStart(2, '0');
  const horas = String(fecha.getUTCHours()).padStart(2, '0');
  const minutos = String(fecha.getUTCMinutes()).padStart(2, '0');
  const segundos = String(fecha.getUTCSeconds()).padStart(2, '0');
  const milisegundos = String(fecha.getUTCMilliseconds()).padStart(3, '0');

  return `${anio}-${mes}-${dia} ${horas}:${minutos}:${segundos}.${milisegundos}000`;
}
